import LockupTitleAuthor from './lockupTitleAuthor'

export default LockupTitleAuthor
